// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.QuerySourceTypeDetails.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import {
  APPROVAL_LEVEL,
  DETECTED_CHANGE_LEVEL,
  DEFAULT_DETAIL_REST_HEIGHT,
  DEFAULT_TABLE_HEIGHT,
  NEW_FIELD,
  DATA_TYPE_CHANGES,
  DELETED_FIELD,
  TENANT_FIELD,
  EXPRESSION_SELECTION
} from 'logic/data/Izenda.DataModelConstants';
import { cond, matches, constant, every, forEach, filter, isEmpty } from 'lodash/fp';
import { QUERY_SOURCE_TYPE } from 'logic/data/Izenda.QuerySourceTypeConfig';
import { TableDefinition } from 'logic/data/Izenda.DataModelConstants';
import connect from 'share/enhancers/Izenda.Connect';
import React, { Component } from 'react';
import classnames from 'classnames';
import { Table, Column } from 'share/components/controls/DataGrid/Izenda.Table';
import Button from 'share/components/controls/Izenda.Button';
import FilterValuesColumn from './Izenda.FilterValuesColumn';
import FilterValueContainer from './FilterValue/Izenda.FilterValueContainer';
import Input from 'share/components/controls/Izenda.Input';
import Validator from 'share/components/hoc/Izenda.Validator';
import CalculatedField from 'share/components/controls/calculatedField/Izenda.CalculatedField';
import PredictedField from 'share/components/controls/predictedField/Izenda.PredictedField';
import PredictedNoModels from 'share/components/controls/predictedField/Izenda.PredictedNoModels';
import { TYPES, MESSAGES } from 'logic/data/Izenda.CalculatedFieldConstants';
import { PM_TYPES, PM_MESSAGES } from 'logic/data/Izenda.PredictedFieldConstants';
import OverflowText from 'share/components/controls/Izenda.OverflowText';
import PropTypes from 'prop-types';
import QuerySourceFieldDetailsStore from 'logic/Izenda.QuerySourceFieldDetailsStore';
import LicenseCheckerConstants from 'logic/data/Izenda.LicenseCheckerConstants';
import { extendColumnDefinitionProps } from './Izenda.SelectAllColumn';

const { QuerySourceTypeDetails: TABLE_DEF } = TableDefinition;
const ValidatorInput = Validator()(Input);

@connect()
export default class QuerySourceTypeDetails extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    searchProperty: PropTypes.string,
    searchValue: PropTypes.string
  };

  /**
   * "select all" state of "visible" and "filterable" column checkboxes.
   */
  state = {
    selectAllCheckedVisible: false,
    selectAllCheckedFilterable: false
  };

  constructor(props) {
    super(props);
    this.renderFilterValueColumns = FilterValuesColumn.render.bind(this);

    this.state = {
      checkPredictionServerStatus : '',
      dbserverStatus : '',
    }
  }

  componentWillUpdate(nextProps)  {
    this.setSelectAllVisibleDefaults(nextProps);
    this.setSelectAllFilterableDefaults(nextProps);
  }

  render() {
    const {
      store,
      height,
      querySourceType,
      store: { editingQuerySourceField },
      authorization
    } = this.props;
    const {
      selectAllCheckedVisible,
      selectAllCheckedFilterable
    } = this.state;
    const hasMachineLearningLicense = authorization.checkLicense(LicenseCheckerConstants.LICENSE_KEY.MachineLearning);

    const displayFieldList = store.displayFieldList || [];
    let newHeight = height > 0 ? height - DEFAULT_DETAIL_REST_HEIGHT : DEFAULT_TABLE_HEIGHT;
    newHeight = newHeight > DEFAULT_TABLE_HEIGHT ? newHeight : DEFAULT_TABLE_HEIGHT;
    let renderAddPredictionFieldButton = null;
    if (hasMachineLearningLicense && this.props.querySourceType !== "Stored Procedure") {
      renderAddPredictionFieldButton = this.renderPredictedFieldButton();
    }

    const columnPropsVisible = extendColumnDefinitionProps(
      TABLE_DEF.visible,
      this.onSelectAllVisible,
      selectAllCheckedVisible);

    const isDisabled = every(x => x.isDisabledFilterable, displayFieldList);
    const columnPropsFilterable = extendColumnDefinitionProps(
      TABLE_DEF.filterable,
      this.onSelectAllFilterable,
      selectAllCheckedFilterable,
      isDisabled);

    return (
      <section className='izenda-SubTable'>
        <div className='title'>
          <div className='content'>
            <strong className='db-name'>{store.getDbSourceName()}</strong>
          </div>
         <div>
          {this.renderAddCalculatedFieldButton()}
          {

            renderAddPredictionFieldButton
          }



          {this.renderExecuteButton()}
        </div>
        </div>

        <Table
          dataSource={displayFieldList}
          onSortChange={this.onSortChange}
          sortInfo={store.pageInfo.colSortDirs}
          isHighLight={this.isHighLight}
          minHeight={newHeight}
          maxHeight={newHeight}
          isLoading={true}
        >
          {/* Column name */}
          <Column {...TABLE_DEF.columnName} cell={this.renderColumnName} />

          {/* Data type */}
          <Column {...TABLE_DEF.dataType} cell={this.renderDataType} />

          {/* Column alias */}
          <Column {...TABLE_DEF.columnAlias} cell={this.renderColumnAlias} />

          {/* Filter value */}
          {<Column {...TABLE_DEF.filter} align='center' cell={this.renderFilterValueColumns} />}

          {/* Visible */}
          <Column {...columnPropsVisible} align='center' cell={this.renderVisible} />

          {/* Filterable */}
          <Column {...columnPropsFilterable} align='center' cell={this.renderFilterable} />

          {/* Delete*/}
          {QUERY_SOURCE_TYPE.STORED_PROC !== querySourceType && (
            <Column {...TABLE_DEF.deletable} align='center' cell={this.renderDeleteColumn} />
          )}
        </Table>

        {editingQuerySourceField && store.isEditingFilter && <FilterValueContainer querySourceDetailStore={store} />}
      </section>
    );
  }

  /**
   * Update visible state.
   * @param {boolean} val
   */
  updateStateVisible = (val: boolean) => {
    if (this.state.selectAllCheckedVisible === val)
      return;
    this.setState({
      selectAllCheckedVisible: val
    });
    if (!val) {
      this.updateStateFilterable(false);
    }
  };

  /**
   * Update filterable state.
   * @param {boolean} val
   */
  updateStateFilterable = (val: boolean) => {
    if (this.state.selectAllCheckedFilterable === val)
      return;
    this.setState({
      selectAllCheckedFilterable: val
    });
  };

  /**
   * selectAllCheckedVisible state synchronization with displayFieldList collection.
   * @param {any} props
   */
  setSelectAllVisibleDefaults = (props: any) => {
    const {
      store: { displayFieldList }
    } = props;
    const isAllChecked = every('isVisible', displayFieldList);
    this.updateStateVisible(isAllChecked);
  };

  /**
   * selectAllCheckedFilterable state synchronization with displayFieldList collection.
   * @param {any} props
   */
  setSelectAllFilterableDefaults = (props: any) => {
    const {
      store: { displayFieldList }
    } = props;
    const availableFilterableFields = filter(x => !x.isDisabledFilterable, displayFieldList);
    const isAllChecked = !isEmpty(availableFilterableFields) && every('isFilterable', availableFilterableFields);
    this.updateStateFilterable(isAllChecked);
  };

  /**
   * Select all visible fields handler
   * @param {boolean} checked
   */
  onSelectAllVisible = (checked: boolean) => {
    const {
      store: { displayFieldList }
    } = this.props;
    forEach(x => x.setVisible(checked), displayFieldList);
    this.updateStateVisible(checked);
  };

  /**
   * Select all filterable fields handler
   * @param {boolean} checked
   */
  onSelectAllFilterable = (checked: boolean) => {
    const {
      store: { displayFieldList }
    } = this.props;
    const availableFilterableFields = filter(x => !x.isDisabledFilterable, displayFieldList);
    if (!availableFilterableFields.length)
      return;
    forEach(x => x.setFilterable(checked), availableFilterableFields);
    this.updateStateFilterable(checked);
  };

  /**
   * On sort change
   * @param {string} columnKey
   * @param {string} sortDir
   */
  onSortChange = (columnKey: string, sortDir: string) => {
    const {
      store,
      store: { hasDetailChange, pageInfo }
    } = this.props;

    let confirmPromise = Promise.resolve();
    if (hasDetailChange) {
      confirmPromise = this.props.confirmDirtyForm(hasDetailChange);
    }

    confirmPromise.then(() => {
      pageInfo.setColSortDirs(columnKey, sortDir);
      store.loadQuerySourceFields();
    });
  };

  /**
   * Render column name
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   */
  renderColumnName = (fieldDetailsStore : QuerySourceFieldDetailsStore) => {
    const {
      details: { physicalChange, approval, matchedTenant }
    } = fieldDetailsStore;



    const isCalculated = !!fieldDetailsStore.details.isCalculated;
    //Predictable field flag
    const isPredictable = !!fieldDetailsStore.details.isPredicated;
    const columnName = fieldDetailsStore.getColumnName();

    const renderChangedIcon = () => {
      const isNew = approval < APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === DETECTED_CHANGE_LEVEL.ADDED;
      const isEdit = approval < APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === DETECTED_CHANGE_LEVEL.MODIFIED;
      const isDelete = approval < APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === DETECTED_CHANGE_LEVEL.DELETED;

      const className = classnames({
        'icon-data success-color': isNew,
        'icon-move-data warning-color': isEdit,
        'icon-data fail-color': isDelete
      });

      const title = cond([
        [matches({ isNew: true }), constant(NEW_FIELD)],
        [matches({ isEdit: true }), constant(DATA_TYPE_CHANGES)],
        [matches({ isDelete: true }), constant(DELETED_FIELD)]
      ])({ isNew, isEdit, isDelete });

      return <OverflowText className={className} tooltip={title} />;
    };

    const renderTenantFieldIcon = () => {
      const className = classnames('u_paddingLeft', {
        'icon-group': matchedTenant
      });
      return <span className={className} title={TENANT_FIELD} />;
    };

    const editCalculatedField = () => {
      const { store } = this.props;
      store.editingQuerySourceField = fieldDetailsStore;
      store.loadFieldNameForExpression(fieldDetailsStore);
      store.loadFieldNameForExpression();

      this.props.openPopup(CalculatedField, {
        store: store.calculatedStore,
        onClose: this.closeCalculatedPopup,
        type: TYPES.EDIT,
        querySourceId: store.details.id,
        value: fieldDetailsStore.details,
        expressionConfig: EXPRESSION_SELECTION,
        isCheckDuplicateWithActualField: false
      });
    };

    //Function to editing predictedField function


    const editPredictedField = () => {
      const { store } = this.props;
      store.editingQuerySourceField = fieldDetailsStore;
      store.loadFieldNameForExpression(fieldDetailsStore);
      store.loadFieldNameForExpression();
      this.props.openPopup(PredictedField, {
        store: store.predictedFieldStore,
        onClose: this.closePredictablePopup,
        type: PM_TYPES.EDIT,
        fieldList:store.fieldList,
        querySourceId: store.details.id,
        value: fieldDetailsStore.details,
        isCheckDuplicateWithActualField: false
      });
    };


    // if(isPredictable){
    //     return isPredictable ? (
    //       <span className='truncate overflow-text' title={columnName} onClick={editPredictedField}>
    //         <span className='source-name'>{columnName}</span>
    //         {renderTenantFieldIcon()}
    //         {renderChangedIcon()}
    //       </span>
    //     ) : (
    //       <span title={columnName} className='truncate overflow-text'>
    //         {columnName}
    //         {renderTenantFieldIcon()}
    //         {renderChangedIcon()}
    //       </span>
    //     );
    // }else if(isCalculated){
    if (isCalculated) {
      return (
      <span className='truncate overflow-text' title={columnName} onClick={editCalculatedField}>
        <span className='source-name'>{columnName}</span>
        {renderTenantFieldIcon()}
        {renderChangedIcon()}
        </span>)
    } else if (isPredictable) {
      return (
        <span className='truncate overflow-text' title={columnName} onClick={editPredictedField}>
          <span className='source-name'>{columnName}</span>
          {renderTenantFieldIcon()}
          {renderChangedIcon()}
      </span>
      )
    } else {
      return (
      <span title={columnName} className='truncate overflow-text'>
        {columnName}
        {renderTenantFieldIcon()}
        {renderChangedIcon()}
      </span>
      )
    };
    //}
  };

  /**
   * Is the text highlight when match searching
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   */
  isHighLight = (fieldDetailsStore: QuerySourceFieldDetailsStore) => {
    const { searchProperty, searchValue } = this.props;
    if (searchValue.length === 0) {
      return false;
    }

    switch (searchProperty) {
      case 'All':
        return (
          String.searchString(fieldDetailsStore.getColumnName(), searchValue, true) ||
          String.searchString(fieldDetailsStore.getDataType(), searchValue, true) ||
          String.searchString(fieldDetailsStore.getColumnAlias(), searchValue, true)
        );
      case 'ColumnName':
        return String.searchString(fieldDetailsStore.getColumnName(), searchValue, true);
      case 'ColumnAlias':
        return String.searchString(fieldDetailsStore.getColumnAlias(), searchValue, true);
      default:
        return false;
    }
  };

  /**
   * Render Data Type column
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   */
  renderDataType = (fieldDetailsStore: QuerySourceFieldDetailsStore) => {
    const dataType = fieldDetailsStore.getDataType();
    return <OverflowText tooltip={dataType} text={dataType} />;
  };

  /**
   * Render Delete column
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   */
  renderDeleteColumn = (fieldDetailsStore: QuerySourceFieldDetailsStore) => {
    const { store, loader } = this.props;
    const {
      details: { approval, physicalChange, isCalculated, isPredicated }
    } = fieldDetailsStore;
    const isDelete = approval < APPROVAL_LEVEL.QUERY_SOURCE_FIELD && physicalChange === DETECTED_CHANGE_LEVEL.DELETED;
   // const disabled = (!isCalculated && !isDelete);
    const disabled = !(isCalculated || isPredicated) && !isDelete
    const classes = classnames('icon-cancel', {
      'disabled-elm': disabled
    });

    const deleteField = () => {
      if (!disabled) {
        let deletePromise = Promise.resolve();
        if (isCalculated) {
          deletePromise = store.hasReportUseCalculatedField(fieldDetailsStore).then(hasUsed => {
            const confirmMessage = hasUsed ? MESSAGES.M02 : MESSAGES.M01;
            return this.props.confirmFn('Confirmation', {
              description: confirmMessage
            });
          });
        }


       if(isPredicated){
          deletePromise = store.hasReportUsePredicatedField(fieldDetailsStore).then(hasUsed => {
            const confirmMessage = hasUsed ? PM_MESSAGES.M02 : PM_MESSAGES.M01;
            return this.props.confirmFn('Confirmation', {
              description: confirmMessage
            });
          });
       }

        deletePromise.then(() => {
          loader.startLoading();
          return store.deleteField(fieldDetailsStore).finally(loader.endLoading.bind(loader));
        });
      }
    };

    return (
      <a onClick={deleteField}>
        <span className={classes} />
      </a>
    );
  };

  /**
   * Render Column Alias
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   * @param {string} key
   * @param {number} index
   */
  renderColumnAlias = (fieldDetailsStore: QuerySourceFieldDetailsStore, key: string, index: number) => {
    const classes = classnames('form-group', {
      'has-error': fieldDetailsStore.aliasError
    });
    const { querySourceIndex } = this.props;

    const updateValue = ({ target: { value } }) => {
      return fieldDetailsStore.setColumnAlias(value);
    };

    return (
      <div className={classes}>
        <ValidatorInput
          type='text'
          className='form-control'
          value={fieldDetailsStore.getColumnAlias()}
          onChange={updateValue}
          title={fieldDetailsStore.getColumnAlias()}
          field={`QuerySources['${querySourceIndex}'].QuerySourceFields['${index}'].Alias`}
        />
      </div>
    );
  };

  /**
   * Render Visible column
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   */
  renderVisible = (fieldDetailsStore: QuerySourceFieldDetailsStore) => {
    const { props, setSelectAllVisibleDefaults, setSelectAllFilterableDefaults } = this;
    const { isVisible, isDisabledVisible } = fieldDetailsStore;

    const updateValue = ({ target: { checked } }) => {
      fieldDetailsStore.setVisible(checked);
      setSelectAllVisibleDefaults(props);
      setSelectAllFilterableDefaults(props);
    };

    return (
      <Input
        type='checkbox'
        checked={isVisible}
        onChange={updateValue}
        disabled={isDisabledVisible}
      />
    );
  };

  /**
   * Render Filterable column
   * @param {QuerySourceFieldDetailsStore} fieldDetailsStore
   */
  renderFilterable = (fieldDetailsStore: QuerySourceFieldDetailsStore) => {
    const { props, setSelectAllFilterableDefaults } = this;
    const { isFilterable, isDisabledFilterable } = fieldDetailsStore;

    const updateValue = ({ target: { checked } }) => {
      fieldDetailsStore.setFilterable(checked);
      setSelectAllFilterableDefaults(props);
    };

    return (
      <Input
        type='checkbox'
        checked={isFilterable}
        onChange={updateValue}
        disabled={isDisabledFilterable}
      />
    );
  };

  /**
   * Render Execute button
   */
  renderExecuteButton() {
    const { localization, querySourceType, store } = this.props;
    if (QUERY_SOURCE_TYPE.STORED_PROC !== querySourceType) {
      return null;
    }

    const onExecuteClick = () => {
      store.executeStoreProc();
    };

    return (
      <Button
        label={localization.getText('COPY_MANAGEMENT_LABEL_EXECUTE')}
        className='u_floatRight btn-setting-default'
        onClick={onExecuteClick}
        disabled={store.isDynamic()}
      />
    );
  }

  /**
   * Render Add Calculated Field button
   */
  renderAddCalculatedFieldButton() {
    const { localization, store, querySourceType } = this.props;
    if (QUERY_SOURCE_TYPE.STORED_PROC === querySourceType) {
      return null;
    }

    const onAddButtonClick = () => {
      store.loadFieldNameForExpression();

      this.props.openPopup(CalculatedField, {
        store: store.calculatedStore,
        onClose: this.closeCalculatedPopup,
        type: TYPES.ADD,
        querySourceId: store.details.id,
        value: {},
        expressionConfig: EXPRESSION_SELECTION,
        isCheckDuplicateWithActualField: false
      });
    };

    return (
      <Button
        className='u_floatRight btn-setting-default'
        label={localization.getText('COPY_MANAGEMENT_LABEL_ADD_FIELD')}
        onClick={onAddButtonClick}
      />
    );
  }

  /**
   * Render Add PredictedField button
   */
  renderPredictedFieldButton() {
    const { localization, store,loader } = this.props;
    const { checkPredictionServerStatus, dbserverStatus } = this.state;
    const onAddPredictedFieldButtonClick = () => {


      // checkPredictionServerStatus : '',
      // dbserverStatus : '',
      // console.log(this.props.store.MachineLearningStore);
      // this.props.store.MachineLearningStore.getpredictionServerDetails().then((data) => {
      //   let predIP = JSON.stringify(data.perdictionServerIP);
      //   this.setState({ checkPredictionServerStatus: predIP });
      // });
      // this.props.store.MachineLearningStore.getMLDBsettings().then((data) => {
      //   let dbconString = JSON.parse(data);
      //   this.setState({ dbserverStatus: dbconString.ConnectionString });

      // });

  this.props.store.MachineLearningStore.getMLDBsettings().then((data) => {
    let dbconString = JSON.parse(data);
    loader.startLoading();
    if((dbconString.ConnectionString)) {
      this.props.store.predictedFieldStore.fetchFromFetcher(store.details.id).then((data)=>{
        this.props.store.PreditectedDetailList = JSON.parse(data);
        if( this.props.store.PreditectedDetailList.success !== false){
            this.props.openPopup(PredictedField, {
            store: store.predictedFieldStore,
            onClose: this.closePredictablePopup,
            type: PM_TYPES.ADD,
            querySourceId: store.details.id,
            fieldList:store.fieldList,
            value: {},
            isCheckDuplicateWithActualField: false
          });
        }else{
          this.props.openPopup(PredictedNoModels, {
            store: store.predictedFieldStore,
           // onClose: this.closePredictablePopup,
            type: PM_TYPES.ADD,
           // querySourceId: store.details.id,
            //value: {},
           // isCheckDuplicateWithActualField: false
          });
        }
        loader.endLoading();
      }).catch( (e) => {
      console.log(e);
    });
    }else{
      this.props.openPopup(PredictedNoModels, {
        store: store.predictedFieldStore,
       // onClose: this.closePredictablePopup,
        type: PM_TYPES.ADD,
       // querySourceId: store.details.id,
        //value: {},
       // isCheckDuplicateWithActualField: false
      }).catch((e)=>{
        console.log(e);
      });
    }
    }
  )};


    return (
      <Button
        className='u_floatRight btn-setting-default set-apart-btn'
        label={localization.getText('COPY_MANAGEMENT_LABEL_PREDICTED_FIELD')}
        onClick={onAddPredictedFieldButtonClick}
      />
    );
  }




  /**
   * On close Calculated Field popup
   * @param {Object} calculatedData
   */
  closeCalculatedPopup = (calculatedData: any) => {
    // Update calculated field
    const { store } = this.props;
    calculatedData && store.addCalculateField(calculatedData);
  }

  /**
 * On close Predicted Field popup
 * @param {object} predictableData
 */

  closePredictablePopup = (predictableData: any) => {
    const { store } = this.props;
    predictableData && store.addPredictableField(predictableData)
}
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/QuerySourceType/Izenda.QuerySourceTypeDetails.js